import { component } from "picoapp";
import { ajaxCartAdd } from "../../utilities/cart";
import { handleButtonEffect } from "./oli-button-effect";
import { BackInStockNotice } from "../../../scripts/pdp";

enum BUTTON_ACTIONS {
  ADD_VARIANT = "add-variant",
  STORE_LOCATOR = "store-locator",
  BACK_IN_STOCK = "back-in-stock",
}

export const buttonAction = component((node: HTMLButtonElement) => {
  function handleButtonAction(e: MouseEvent) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const action = node.dataset.action;
    if (!action) return;
    switch (action) {
      case BUTTON_ACTIONS.ADD_VARIANT:
        addVariant(node);
        break;
      case BUTTON_ACTIONS.STORE_LOCATOR:
        storeLocator(node);
        break;
      case BUTTON_ACTIONS.BACK_IN_STOCK:
        backInStock(node);
        break;
      default:
        break;
    }
  }

  node.addEventListener("click", handleButtonAction);

  return () => {
    node.removeEventListener("click", handleButtonAction);
  };
});

const addVariant = async (node: HTMLElement) => {
  const variantIdElement = node.closest<HTMLElement>("[data-variant-id]");
  const variantId = variantIdElement?.dataset.variantId;
  const amount = Number(variantIdElement?.dataset.quantity) ?? 1;

  if (!variantId) return;
  try {
    const res = await ajaxCartAdd([{ id: variantId, quantity: amount }]);
    handleButtonEffect(node);
    return res;
  } catch (e) {
    console.error(e);
  }
};

const storeLocator = (node: HTMLElement) => {
  const upcCodeElement = node.closest<HTMLElement>(
    "[data-product-locator-upc]"
  );
  const upcCode = upcCodeElement?.dataset.productLocatorUpc;
  if (!upcCode) return;

  try {
    window.basketful?.openBasketful({
      productLocatorUpc: upcCode,
      productLocator: true,
    });
  } catch (e) {
    console.error(e);
  }
};

const backInStock = (node: HTMLElement) => {
  const productDataElement = node.closest<HTMLElement>("[data-variant-id]");
  const variantId = productDataElement?.dataset.variantId;
  const productTitle = productDataElement?.dataset.productTitle;
  const productId = productDataElement?.dataset.productId;

  if (!variantId || !productTitle || !productId) return;

  const backInStockModal = new BackInStockNotice();
  backInStockModal.variant.id = variantId;
  backInStockModal.variant.title = productTitle;
  backInStockModal.variant.productId = productId;
  backInStockModal._mount();
};

// Rebuy recommendations section
document.addEventListener('DOMContentLoaded', () => {
  const productList = document.querySelectorAll('rebuy-recommendations');
  if (productList.length) {

    productList.forEach(item => {
      item.addEventListener('click', function (e) {
        const button = (e.target as HTMLElement).closest<HTMLElement>('[data-action="add-variant"]');
        if (!button) return
        e.preventDefault();
        e.stopImmediatePropagation();
        addVariant(button);
      });
    })
  }
});

